module.exports = "/public/images/a744ff9e31b8d8d0d9c9713c15c95c4c.png";